module.exports = __webpack_public_path__ + "static/img/Salesi-Foketi.10e1978.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Salesi-Foketi.jpg
// module id = ERAM
// module chunks = 0